// **********************************************************
// Hero slider
// **********************************************************

const heroSwiperElements = document.querySelectorAll('[data-slider="hero-slider"]');
const heroSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 1000,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

heroSwiperElements.forEach((el) => {
  const mainSliderParent = el.closest('.hero-slider');
  const paginationElement = mainSliderParent.querySelector('.swiper-pagination');

  heroSliderOptions.pagination.el = paginationElement;

  new Swiper(el, heroSliderOptions);
});
